import axios from './http';
import global from '@/constants/Global.constants'

export default {
  findUpdateBalance (params) {//查询经销商余额
    return axios.post(global.CMC_BASE + '/dear/findUpdateBalance', params);
  }
}



// WEBPACK FOOTER //
// ./src/request/dealer.js